var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('loading',{attrs:{"exibir":_vm.layout.exibirLoading}}),_c('erro-ws',{attrs:{"exibir":_vm.layout.erroWebService}}),_c('mensagem-form',{attrs:{"layout":_vm.layout}}),_c('v-btn',{on:{"click":_vm.exibir}},[_vm._v("Fechar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }